import { parseMatchToRankingRequest } from '@features/rankings/parsers/match-ranking.parser'
import { RankingRequest } from '@features/rankings/models/ranking.model'
import { getMetricValueAndContext } from '@core/utils/context-menu.utils'
import { Match } from '@core/models/match.models'
import { ContextMenuItemEvent } from '@core/models/context-menu.models'
import { Aggregation } from '@features/aggregations/models/aggregations.models'

export const resolveMatchRankingRequest = (
  payload: ContextMenuItemEvent,
  aggregationMode: Aggregation
): RankingRequest => {
  const { context, value, mode } = getMetricValueAndContext<Match>(payload, aggregationMode)

  return parseMatchToRankingRequest(context, value, mode)
}
